import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { baseurly } from '../../utils/apis.ts';
import { X_API_KEY } from '../../utils/apis.ts';
import { baseurl } from '../../utils/apis.ts';
import PdfDocumentLayout from '../../components/PdfDocumentLayout.tsx';

interface DesignDocument {
  id: number;
  file: string;
  title: string;
  // You may not need these complex types for building_id and vehicle_model_id:
  building_id: number;
  vehicle_model_id: number;
}

const DesignDocumentPage: React.FC = () => {
  const { docId } = useParams<{ docId: string }>();
  const [designDoc, setDesignDoc] = useState<DesignDocument | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (docId) {
      fetch(`${baseurly}/design_docs/${docId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'X-API-KEY': X_API_KEY,
        },
        credentials: "include",
      })
        .then((res) => {
          if (!res.ok) {
            throw new Error('Failed to fetch design document');
          }
          return res.json();
        })
        .then((data: DesignDocument) => {
          console.log("Fetched design document:", data);
          setDesignDoc(data);
          setLoading(false);
        })
        .catch((err) => {
          console.error('Error fetching design document:', err);
          setError('Unable to load design document');
          setLoading(false);
        });
    }
  }, [docId]);

  // Construct the file URL. If designDoc.file is a relative URL, prepend baseurly + "files/"
  const fileUrl =
    designDoc && designDoc.file
      ? designDoc.file.startsWith('http')
        ? designDoc.file
        : `${baseurl}files/${designDoc.file}`
      : '';

  if (loading) {
    return (
      <div className="min-h-screen bg-blue-900 p-6">
        <div className="text-white text-center mt-20">Loading...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-blue-900 p-6">
        <div className="text-white text-center mt-20">{error}</div>
      </div>
    );
  }

  return (
    <PdfDocumentLayout
      title={designDoc?.title}
      fallbackTitle="Design Document"
      fileUrl={fileUrl}
      hasDocument={Boolean(designDoc && designDoc.file)}
      emptyMessage="No design document found."
    />
  );
};

export default DesignDocumentPage;
